import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadRentals } from "../interfaces/rentInterface";
import CardView from "./atoms/CardView";
import Filters from "./filters/filters";
import { InfoCircleOutlined, UnderlineOutlined } from "@ant-design/icons";
import { Col, Row,Spin,Button } from "antd";
import { clearRentInfo } from "../features/rentSlice";
import { checkEqual } from "../helpers/helper";
import { FormNavigator } from "../dynamicform/formNavigator";
import PersistantRef from "./atoms/PersistantRef";
import { useNavigate } from "react-router-dom";
import UploadAction from "./BulkAction";
import CenteredDisplay from "./atoms/CenteredContent";
import HoverUserCard from "./atoms/HoverUserCard";
const ScaleFlowIcon = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 16 16" className="opacity-70 shrink-0">
    <rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.9" />
    <rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.6" />
    <rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.6" />
    <rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity="0.3" />
  </svg>
);

const ScaleFlowTourButton = ({ url = "YOUR_URL_HERE", label = "ScaleFlow tour →" , click=()=>{}}) => (
  <button
    onClick={() => click()}
    className="inline-flex bg-blend-color-dodge items-center gap-2 rounded-md border border-gray-300 bg-transparent px-2 py-1 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer"
  >
    <ScaleFlowIcon />
    {label}
  </button>
);

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [view, setView] = useState("card");
  const [storeKey, setStoreKey] = useState("rent");
  const formNavigator  = FormNavigator(dispatch)
  const [uploadAction , setUploadAction ] = useState(false)
  // console.log(storeKey);
  var data = useSelector((state) => state[storeKey]);
  var availablePages = useSelector(
    (state) => new Set(Object.keys(state[storeKey]["data"]))
  );
  const role = useSelector((state)=>state.workspace.role.roleString)
  const email = useSelector((state)=>state.workspace.loggedInUser)
  const page = useSelector((state) => state[storeKey]["page"]);
  const limit = useSelector((state) => state[storeKey]["limit"]);
  const totalData = useSelector((state) => state[storeKey]["totalData"]);
  const rentalFilters = useSelector(
    (state) => state[storeKey]["rentalFilters"]
  );
  const previousRentalFilters = new PersistantRef('previousRentalFilters')


  useEffect(()=>{

       loadRentals(
      dispatch,
      undefined,
      undefined,
      undefined,
      undefined,
      rentalFilters
    );

  },[])
  useEffect(() => {



      if(Object.keys(rentalFilters).length == 0 && Object.keys(previousRentalFilters.getValue()).length == 0){
        return
      }
      if (checkEqual(rentalFilters, previousRentalFilters.getValue())) {
        dispatch(clearRentInfo());
        previousRentalFilters.setValue(rentalFilters);
        return
      }

    loadRentals(
      dispatch,
      undefined,
      undefined,
      undefined,
      undefined,
      rentalFilters
    );
    previousRentalFilters.setValue(rentalFilters);
  }, [rentalFilters ]);
  if (view === "card") {
    data = Object.values(data?.["data"]).flat();
  }
  // console.log(data);
  return (
    data && (
      <>

       <UploadAction open={uploadAction} closeModal={()=>setUploadAction(false)}/>
        <Row>
          <Col span={14}>
            <Filters dispatch={dispatch} values={rentalFilters} />

          </Col>{" "}
          <Col
            span={10}
            style={{ margin: "auto", textAlign: "right", right: 10 }}
          >


<HoverUserCard  className="ml-2" email={email} role={role} extra={
  <>
          <ScaleFlowTourButton className="ml-2" click={()=>navigate('/tour')}/>
              <Button onClick={()=>{formNavigator.rental(-1)}}>Create</Button>
            <Button type="primary"  onClick={()=>{setUploadAction(true)}}>Bulk Upload</Button>
  </>
}/>

          </Col>{" "}

        </Row>
        {/* <InfoCircleOutlined /> Found {totalData} Entries */}
        { data.length == 0 && Object.keys(rentalFilters).length == 0 ?
        <CenteredDisplay title={"Rentals"} isLoading={!(data.length == 0 && Object.keys(rentalFilters).length == 0 )} description={"Create a Rental to Get Started"}  actionText={"Add"} actionCallback={()=>formNavigator.rental(-1)}/>:
        <CardView
          config={"rental"}
          page={page}
          data={data}
          limit={limit}
          totalData={totalData}
          availablePages={availablePages}
          filters={rentalFilters}
        />}
      </>
    )
  );
};

export default Dashboard;
